import { Type } from 'typebox';
export const DocumentationRating = Type.Object({
    childId: Type.Optional(Type.String({ minLength: 1 })),
    childKey: Type.String({ minLength: 1 }),
    dimensionId: Type.String({ minLength: 1 }),
    level: Type.String({ minLength: 1 })
});
